export function getTeamLabel(teamNumber, squadTeams) {
  if (!squadTeams || squadTeams.length === 0) return 'Team ' + (teamNumber || 1)
  const team = squadTeams.find(t => String(t.team_number) === String(teamNumber))
  return team ? team.label : 'Team ' + teamNumber
}

export function hasMultipleTeams(squadTeams) {
  return squadTeams && squadTeams.length > 1
}